module.exports = __webpack_public_path__ + "img/value_mock.646ecc61.png";